import { TLink } from "@/components/molecules/Button";
import { faTurnDown } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const anchors = [
  { title: "About", href: "#about" },
  { title: "Greeting", href: "#greeting" },
  { title: "Identity", href: "#identity" },
  { title: "History", href: "#history" },
  { title: "Corporate Profile", href: "#profile" },
  { title: "Access Map", href: "#accessMap" },
];

export const AboutNav = () => {
  return (
    <>
      <div className="bg-white py-4 px-6 sm:px-8 md:px-12 md:py-6 lg:py-8 xl:px-0">
        <ul className="mx-auto mb-4 flex max-w-7xl flex-wrap justify-end gap-2 fluid-text-[11px,16px] md:mb-0 md:gap-6 md:px-10">
          {anchors.map((anchor) => (
            <li key={anchor.index}>
              <TLink
                href={anchor.href}
                variant="mono"
                color="p"
                className="group"
              >
                {anchor.title}
                <FontAwesomeIcon
                  icon={faTurnDown}
                  className="ml-1 text-icn group-hover:text-hov sm:ml-2"
                />
              </TLink>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};
